import Cookies from "js-cookie";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom/dist";
import { toast } from "react-toastify";

const AdminProtectedRoute = ({ file }) => {
  const { isLogin, meData } = useSelector((state) => state?.commonReducer);
  if (!isLogin || meData?.role === "user") {
    return [<Navigate to="/" replace />, toast.error("Please Login First")];
  } else {
    return file;
  }
  return <></>;
};

export default AdminProtectedRoute;
